<template>
  <div class="bud">
    <div class="bud__top-banner">
      <div class="content">
        <div class="bud__top-banner-row">
          <div class="bud__top-banner-text">
            <div class="bud__top-banner-title">Нефропротекция в зените</div>
            <div class="bud__top-banner-description">
              Ваш шанс задать вопрос эксперту!
            </div>
            <a href="#timer" class="bud__top-banner-button button button_white-blue">Смотреть</a>
          </div>
          <div class="bud__top-banner-img">
            <img
              :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/banner.png 2x`" />
          </div>
        </div>
      </div>
    </div>
    <div class="bud__page">
      <div class="content">
        <div class="bud__info">
          <div class="bud__info-row">
            <div class="bud__info-icon">
              <img
                :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/info-icon.png 2x`" />
            </div>
            <div class="bud__info-text">
              <div class="bud__info-title">
                ХБП: Между строк и между врачей! То ли терапевт, то ли нефролог,
                то ли никто…
              </div>
              <div class="bud__info-description">
                Болезнь словно потерялась среди врачей: нефрологов, терапевтов,
                эндокринологов. Из-за этого пациенты остаются без должного
                внимания, а само заболевание не контролируется так, как
                необходимо.<sup>1-4</sup>
              </div>
            </div>
          </div>
        </div>
        <div class="bud__speaker-container">
          <div class="bud__speaker-title">Больше нельзя молчать!</div>
          <div class="bud__speaker-description">
            Задайте вопрос профессору Наталье Андреевне Козиоловой.
            <br />Узнайте то, что может спасти жизнь пациента.
          </div>
          <div class="bud__speaker">
            <div class="bud__speaker-img">
              <img
                :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/speaker.jpg`" />
            </div>
            <div class="bud__speaker-text">
              <div class="bud__speaker-tag">Профессор</div>
              <div class="bud__speaker-name">Козиолова Наталья Андреевна</div>
              <div class="bud__speaker-position">
                Ведущий эксперт в лечении ХБП
              </div>
              <div class="bud__speaker-info" id="timer">
                Член Президиума Правления Российского кардиологического
                общества, Президент Пермского краевого кардиологического
                общества, Заведующая кафедрой внутренних болезней и кардиологии
                Пермского государственного медицинского университета им.
                академика Е.А. Вагнера
              </div>
            </div>
          </div>
        </div>

        <div class="bud__form-final mt-16">
          <div class="bud__form-final-block">
            <div class="bud__form-final-block-timer" v-show="eventDate">
              <div class="bud__form-final-block-timer-title"> Вебинар с профессором Козиоловой Натальей Андреевной
                состоится 18 декабря в 15:00 МСК</div>

              <div class="bud__form-final-block-timer-row" v-if="timerResult">
                <div class="bud__form-final-block-timer-item" v-if="timerResult.days">
                  <div class="bud__form-final-block-timer-item-value">
                    {{ timerResult.days }}
                  </div>
                  <div class="bud__form-final-block-timer-item-label">
                    {{
                      helpers.getNoun(timerResult.days, "день", "дня", "дней")
                    }}
                  </div>
                </div>
                <div class="bud__form-final-block-timer-item" v-if="timerResult.hours">
                  <div class="bud__form-final-block-timer-item-value">
                    {{ timerResult.hours }}
                  </div>
                  <div class="bud__form-final-block-timer-item-label">
                    {{
                      helpers.getNoun(timerResult.hours, "час", "часа", "часов")
                    }}
                  </div>
                </div>
                <div class="bud__form-final-block-timer-item" v-if="timerResult.minutes">
                  <div class="bud__form-final-block-timer-item-value">
                    {{ timerResult.minutes }}
                  </div>
                  <div class="bud__form-final-block-timer-item-label">
                    {{
                      helpers.getNoun(
                        timerResult.minutes,
                        "минуту",
                        "минуты",
                        "минут"
                      )
                    }}
                  </div>
                </div>
                <div class="bud__form-final-block-timer-item" v-if="timerResult.seconds">
                  <div class="bud__form-final-block-timer-item-value">
                    {{ timerResult.seconds }}
                  </div>
                  <div class="bud__form-final-block-timer-item-label">
                    {{
                      helpers.getNoun(
                        timerResult.seconds,
                        "секунду",
                        "секунды",
                        "секунд"
                      )
                    }}
                  </div>
                </div>
              </div>
              <iframe src="https://vkvideo.ru/video_ext.php?oid=-171891349&id=456239745&hash=51e81d8ddd059fe0"
                frameborder="0" allowfullscreen="1"
                allow="autoplay; encrypted-media; fullscreen; picture-in-picture"></iframe>
            </div>
          </div>
        </div>

        <div class="bud__form" id="form" v-if="false">
          <div class="bud__form-title">
            Ни один вопрос не останется без ответа!
          </div>
          <div class="bud__form-form" v-show="!formSended">
            <input :class="{
              'bud__form-input_fill': name.value,
              'bud__form-input_error': name.isError,
            }" class="bud__form-input" type="text" v-model="name.value" placeholder="Введите свое имя *" />
            <input :class="{
              'bud__form-input_fill': secondName.value,
              'bud__form-input_error': secondName.isError,
            }" class="bud__form-input" type="text" v-model="secondName.value" placeholder="Введите свою фамилию *" />
            <input :class="{
              'bud__form-input_fill': email.value,
              'bud__form-input_error': email.isError,
            }" class="bud__form-input" type="email" v-model="email.value"
              placeholder="Укажите адрес Вашей электронный почты для обратной связи *" />
            <textarea :class="{
              'bud__form-input_fill': question.value,
              'bud__form-input_error': question.isError,
            }" class="bud__form-input bud__form-textarea" v-model="question.value"
              placeholder="Введите Ваш вопрос связанный с диагностикой и терапией ХБП? *"></textarea>
            <label class="bud__form-checkbox" :class="{ 'bud__form-checkbox_error': pd.isError }">
              <div class="bud__form-checkbox-input">
                <input type="checkbox" v-model="pd.value" />
                <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.87303 13L0 6.82544L1.23818 5.52369L5.87303 10.3965L15.7618 0L17 1.30175L5.87303 13Z"
                    fill="#095092" />
                </svg>
              </div>
              <div class="bud__form-checkbox-label">
                Я даю свое согласие на <a style="text-decoration: underline" href="https://az-most.ru/register"
                  target="_blank">обработку персональных данных</a>
                *
              </div>
            </label>
            <label class="bud__form-checkbox" :class="{ 'bud__form-checkbox_error': notify.isError }">
              <div class="bud__form-checkbox-input">
                <input type="checkbox" v-model="notify.value" />
                <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.87303 13L0 6.82544L1.23818 5.52369L5.87303 10.3965L15.7618 0L17 1.30175L5.87303 13Z"
                    fill="#095092" />
                </svg>
              </div>
              <div class="bud__form-checkbox-label">
                Я даю свое согласие на получение email-сообщения от «АстраЗенека
                Фармасьютикалз» *
              </div>
            </label>
            <div class="bud__form-description">
              Если вы хотите сообщить о претензии в отношении качества или
              подлинности лекарственного препарата, вы можете обратиться в ООО
              «АстраЗенека Фармасьютикалз»: Сделать это вы можете
              по телефону: +7 (495) 799-56-99 Или по электронной
              почте: ProductQuality.ru@astrazeneca.com Если вас интересует
              медицинская и научная информация о препаратах компании, вы можете
              отправить запрос на её получение с помощью электронной
              почты Medinfo.ru@astrazeneca.com или по телефону +7 (495)
              799-56-99
              <br />
              «Если вам стало известно о нежелательном явлении, возникшем при
              применении лекарственного препарата компании «АстраЗенека»,
              пожалуйста, сообщите нам по электронной
              почте Safety.Russia@astrazeneca.com или по телефону  +7 (495)
              799-56-99».
            </div>
            <div class="bud__form-button button button_white-blue" @click="send">
              Отправить
            </div>
          </div>
          <div class="bud__form-final" v-show="formSended">
            <div class="bud__form-final-block">
              <div class="bud__form-final-block-text">
                Спасибо за Ваш вопрос! <br />
                Ожидайте от нас письмо с информацией о прямом эфире <br />
                с экспертом и ответом на Ваш вопрос.
              </div>
            </div>
            <div class="bud__form-final-description" v-show="!isAuth">
              <a :href="$root.ssoLinks.login">Авторизуйтесь</a> /
              <a :href="$root.ssoLinks.registration">Зарегистрируйтесь</a>,
              чтобы не пропустить ответ эксперта на Ваш вопрос
            </div>
            <div @click="repeatForm" class="bud__form-final-button button button_white-blue">
              Задать новый вопрос
            </div>
          </div>
        </div>

      </div>
      <div class="bud__casts">
        <div class="content">
          <div class="bud__casts-title">
            Трансляции
          </div>
          <div class="bud__casts-items">
            <div class="bud__casts-item" :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/%D0%92%D1%8B%D0%BF%D1%83%D1%81%D0%BA%201-min.mp4`">
              <div class="bud__casts-item-head">
                <div class="bud__casts-item-tag">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 6L18 12L8 18V6Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Выпуск 1
                </div>
                <div class="bud__casts-item-title">
                  Нефпротекция в Зените
                </div>
                <div class="bud__casts-item-time">
                  29 сентября 14:00 (МСК)
                </div>
              </div>
             
            </div>
            <div class="bud__casts-item" :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/%D0%92%D1%8B%D0%BF%D1%83%D1%81%D0%BA%202-min.mp4`">
              <div class="bud__casts-item-head">
                <div class="bud__casts-item-tag">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 6L18 12L8 18V6Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Выпуск 2
                </div>
                <div class="bud__casts-item-title">
                  Нефпротекция в Зените
                </div>
                <div class="bud__casts-item-time">
                  29 октября 15:00 (МСК)
                </div>
              </div>
            </div>
            <div class="bud__casts-item" :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/%D0%92%D1%8B%D0%BF%D1%83%D1%81%D0%BA%203-min.mp4`">
              <div class="bud__casts-item-head">
                <div class="bud__casts-item-tag">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 6L18 12L8 18V6Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  Выпуск 3
                </div>
                <div class="bud__casts-item-title">
                  Нефпротекция в Зените
                </div>
                <div class="bud__casts-item-time">
                  12 ноября 15:00 (МСК)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bud__footer">
        <div v-if="false" class="bud__footer-glass-block">
          <div class="bud__footer-glass-block-title">
            KDIGO 2024<sup>5</sup>
          </div>
          <div class="bud__footer-glass-block-description">
            иНГЛТ-2 рекомендованы для терапии взрослых пациентов с ХБП при
            наличии:
          </div>
        </div>
        <div v-if="false" class="bud__footer-row">
          <div class="bud__footer-item">
            рСКФ ≥ 20 мл/мин/1,73 м² и отношением А/Кр мочи ≥ 200 мг/г (1А)
          </div>
          <div class="bud__footer-item">
            рСКФ 20-45 мл/мин/1,73 м² и отношением А/Кр мочи &lt; 200 мг/г
            (2B)
          </div>
        </div>
        <img class="bud__footer-img"
          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/bud/footer.png 2x`" />
      </div>
      <div class="bud__sources">
        <div class="content">
          <div class="bud__sources-title">Список литературы: </div>
          <ol class="bud__sources-list">
            <li>
              Клинические рекомендации Хроническая болезнь почек, 2024
              <a href="https://cr.minzdrav.gov.ru/recomend/469_3"
                target="_blank">https://cr.minzdrav.gov.ru/recomend/469_3</a>
              дата обращения 05.05.2025;
            </li>
            <li>Sundström J, et al. Lancet Reg Health Eur2022;20:100438; </li>
            <li>Tangri N, et al. AdvTher2023;40:2869–2885; </li>
            <li>Tangri N, et al. BMJ Open 2023;13:e067386; </li>
            <li>KDIGO CKD Work Group. Kidney Int. 2024;105(4S):S117–S314.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BudByBud",
  data: () => ({
    name: {
      isError: false,
      value: "",
    },
    secondName: {
      isError: false,
      value: "",
    },
    email: {
      isError: false,
      value: "",
    },
    question: {
      isError: false,
      value: "",
    },
    pd: {
      isError: false,
      value: false,
    },
    notify: {
      isError: false,
      value: false,
    },
    formSended: false,
    eventDate: "2025-09-29T13:45:05+03:00", // вставить дату мероприятия для вывода таймера. формат: 2023-09-19T17:19:05+03:00
    timerResult: null,
  }),
  computed: {
    ...mapGetters(["isAuth", "user"]),
  },
  methods: {
    send() {
      let error = false;
      if (!this.name.value.replace(/ /g, "")) {
        this.setFieldStatus(this.name);
        error = true;
      }
      if (!this.secondName.value.replace(/ /g, "")) {
        this.setFieldStatus(this.secondName);
        error = true;
      }
      if (
        !this.email.value.replace(/ /g, "") ||
        !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/g.test(this.email.value)
      ) {
        this.setFieldStatus(this.email);
        error = true;
      }
      if (!this.question.value.replace(/ /g, "")) {
        this.setFieldStatus(this.question);
        error = true;
      }
      if (!this.pd.value) {
        this.setFieldStatus(this.pd);
        error = true;
      }
      if (!this.notify.value) {
        this.setFieldStatus(this.notify);
        error = true;
      }
      if (error) return;
      this.$axios(`/api/expert-question/`, {
        method: "POST",
        data: {
          appeal: `${this.name.value} ${this.secondName.value}`,
          email: this.email.value,
          text: this.question.value,
          is_agree_to_use_of_personal_data: this.pd.value,
          is_agree_to_get_answer: this.notify.value,
        },
      }).finally(() => {
        this.$nextTick(() => {
          this.formSended = true;
          document
            .querySelector(".bud__form")
            .scrollIntoView({ block: "center" });
        });
      });
    },
    repeatForm() {
      this.name.value = "";
      this.email.value = "";
      this.question.value = "";
      this.pd.value = false;
      this.notify.value = false;
      this.formSended = false;
    },
    setFieldStatus(f, e = true, time = 2000) {
      this.$set(f, "isError", e);
      setTimeout(() => {
        this.$set(f, "isError", false);
      }, time);
    },
    timer() {
      let date = new Date();
      const dateEnd = new Date(this.eventDate);
      const diff = date.getTime() / 1000 - dateEnd.getTime() / 1000;
      this.$set(this, "timerResult", null);
      if (diff > 0) return;
      this.$set(this, "timerResult", {});
      let months = Math.abs(diff) / 2592000;
      let fullMonths = Math.floor(months);
      let days = (months - Math.floor(months)) * 30;
      let fullDays = Math.floor(days);
      let hours = (days - Math.floor(days)) * 24;
      let fullHours = Math.floor(hours);
      let minutes = (hours - Math.floor(hours)) * 60;
      let fullMinutes = Math.floor(minutes);
      let seconds = (minutes - Math.floor(minutes)) * 60;
      let fullSeconds = Math.round(seconds);
      this.$set(this, "timerResult", {});
      if (fullMonths) {
        this.$set(this.timerResult, "months", fullMonths);
      }
      if (fullDays) {
        this.$set(this.timerResult, "days", fullDays);
      }
      if (fullHours) {
        this.$set(this.timerResult, "hours", fullHours);
      }
      if (fullMinutes) {
        this.$set(this.timerResult, "minutes", fullMinutes);
      }
      if (fullSeconds) {
        this.$set(this.timerResult, "seconds", fullSeconds);
      }
    },
  },
  mounted() {
    this.timer();
    this.interval = setInterval(this.timer, 1000);
    if (this.isAuth) {
      this.name.value = this.user.first_name;
      this.secondName.value = this.user.last_name;
      this.email.value = this.user.email;
    }
  },
};
</script>

<style lang="scss" scoped>
.bud {
  background-color: #6996bf;

  & .content {
    @media screen and (max-width: 1220px) {
      padding: 0 16px;
    }
  }

  &__top-banner {
    padding: 40px 0;
    position: relative;
    background: linear-gradient(180deg, #1b5889 0%, #6996bf 100%);
    height: 600px;

    @media screen and (max-width: 1220px) {
      height: auto;
    }

    &-row {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 32px;

      @media screen and (max-width: 767px) {
        flex-direction: column;
      }
    }

    &-text {
      width: 50%;
      flex-shrink: 0;

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    &-img {
      width: 100%;

      & img {
        max-width: 100%;
      }
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 70px;
      line-height: 80px;
      color: #ffffff;

      @media screen and (max-width: 1220px) {
        font-size: 42px;
        line-height: 50px;
      }

      @media screen and (max-width: 767px) {
        text-align: center;
      }
    }

    &-description {
      margin-bottom: 20px;
      margin-top: 32px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      color: #ffffff;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
        line-height: 18px;
      }

      @media screen and (max-width: 767px) {
        margin: 20px auto;
        max-width: 50%;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
      }
    }

    &-button {
      margin-bottom: auto;
      font-size: 22px;
      padding: 16px 32px;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
        line-height: 18px;
      }
    }
  }

  &__page {
    overflow: hidden;
  }

  &__info {
    padding: 80px 0;

    &-row {
      display: grid;
      grid-template-columns: 182px 1fr;
      gap: 32px;
      align-items: center;

      @media screen and (max-width: 1220px) {
        grid-template-columns: 130px 1fr;
      }

      @media screen and (max-width: 767px) {
        display: flex;
        flex-direction: column-reverse;
      }
    }

    &-icon {
      width: 100%;

      @media screen and (max-width: 767px) {
        width: 150px;
      }

      & img {
        width: 100%;
      }
    }

    &-title {
      margin-bottom: 20px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 55px;
      color: #ffffff;

      @media screen and (max-width: 1220px) {
        font-size: 32px;
        line-height: 36px;
      }

      @media screen and (max-width: 767px) {
        font-size: 24px;
      }
    }

    &-description {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      color: #ecebeb;

      @media screen and (max-width: 1220px) {
        font-size: 20px;
        line-height: 24px;
      }

      @media screen and (max-width: 767px) {
        font-size: 18px;
      }
    }
  }

  &__speaker {
    border-radius: 20px;
    overflow: hidden;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 20px 60px 60px;
    gap: 60px;
    border: 3px solid #095092;

    @media screen and (max-width: 1220px) {
      padding: 20px 30px 30px;
      gap: 32px;
      align-items: flex-end;
    }

    @media screen and (max-width: 767px) {
      flex-direction: column;
    }

    &-title {
      margin-bottom: 20px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 55px;
      text-align: center;
      color: #ffffff;

      @media screen and (max-width: 1220px) {
        font-size: 32px;
      }

      @media screen and (max-width: 767px) {
        font-size: 24px;
      }
    }

    &-description {
      margin-bottom: 40px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 28px;
      text-align: center;
      color: #ecebeb;

      @media screen and (max-width: 1220px) {
        font-size: 20px;
      }

      @media screen and (max-width: 767px) {
        font-size: 18px;
      }
    }

    &-text {
      margin: auto 0;
    }

    &-img {
      width: 30%;
      flex-shrink: 0;
      border-radius: 20px;
      overflow: hidden;

      @media screen and (max-width: 767px) {
        width: 100%;
      }

      & img {
        width: 100%;
      }
    }

    &-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 99px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 20px;
      color: #ffffff;
      width: fit-content;
      padding: 16px 32px;
      background-color: #1b5889;
      margin: 0 0 32px;

      @media screen and (max-width: 1220px) {
        font-size: 14px;
        padding: 8px 16px;
        margin-bottom: 24px;
      }
    }

    &-name {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 42px;
      line-height: 55px;
      color: #095092;

      @media screen and (max-width: 1220px) {
        font-size: 22px;
        line-height: 22px;
        margin-bottom: 16px;
      }
    }

    &-position {
      margin-bottom: 16px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 31px;
      color: #6996bf;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 8px;
      }
    }

    &-info {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      color: #101828;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }

  &__form {
    margin: 80px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    @media screen and (max-width: 1220px) {
      margin: 40px auto;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
    }

    &-title {
      margin-bottom: 32px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 44px;
      text-align: center;
      color: #fff;

      @media screen and (max-width: 1220px) {
        font-size: 24px;
        line-height: 28px;
      }
    }

    &-form {
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }

    &-input {
      display: block;
      width: 100%;
      height: 80px;
      padding: 30px 20px;
      border-radius: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      background-color: #fff;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 23px;
      color: #000000;
      border: 3px solid #1b5889;
      margin-bottom: 32px;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
      }

      &::placeholder {
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #6996bf;

        @media screen and (max-width: 1220px) {
          font-size: 14px;
        }
      }

      &_fill {
        border-color: #095092;
      }

      &_error {
        border-color: red;

        &::placeholder {
          color: red;
        }
      }
    }

    &-textarea {
      height: 160px;
      resize: none;
    }

    &-checkbox {
      margin-bottom: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      align-self: flex-start;
      gap: 12px;
      cursor: pointer;

      &_error {
        & .bud__form-checkbox-label {
          color: red;
        }
      }

      &-input {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        border-radius: 4px;
        background-color: #fff;
        border: 3px solid #1b5889;
        display: flex;
        justify-content: center;
        align-items: center;

        &>svg {
          width: 80%;
          height: auto;
          transition: 0.3s;
          opacity: 0;
        }

        & input {
          display: none;

          &:checked {
            &~* {
              opacity: 1;
            }
          }
        }
      }

      &-label {
        margin: auto 0;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 20px;
        color: #fff;
      }
    }

    &-description {
      margin: 16px 0;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #cecece;

      @media screen and (max-width: 1220px) {
        font-size: 16px;
        line-height: 18px;
      }
    }

    &-button {
      margin: 0 auto;
      font-size: 22px;
      padding: 16px 32px;

      @media screen and (max-width: 1220px) {
        font-size: 18px;
        line-height: 20px;
      }
    }

    &-final {
      width: 100%;

      &-block {
        padding: 30px 20px;
        background-color: #fff;
        border: 3px solid #095092;
        border-radius: 20px;
        overflow: hidden;
        width: 100%;

        &-text {
          font-family: "Roboto", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 22px;
          line-height: 26px;
          text-align: center;
          color: #000000;

          @media screen and (max-width: 1220px) {
            font-size: 16px;
            line-height: 18px;
          }
        }

        &-timer {
          & video {
            width: 100%;
            height: auto;
            aspect-ratio: 16/9;
          }

          & iframe {
            width: 100%;
            height: auto;
            aspect-ratio: 16/9;
          }

          &-title {
            margin-bottom: 16px;
            font-family: "Roboto", sans-serif;
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 26px;
            text-align: center;
            color: #000000;

            &::before {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background-color: red;
              animation: blink 0.5s linear infinite backwards alternate;
              display: inline-block;
              content: "";
              flex-shrink: 0;
            }
          }

          @keyframes blink {
            from {
              opacity: 0;
            }

            to {
              opacity: 1;
            }
          }

          &-row {
            margin-top: 16px;
            display: grid;
            grid-template-columns: repeat(4, auto);
            justify-content: center;
            gap: 32px;
          }

          &-button {
            margin: 32px auto 0;
            font-size: 22px;
            padding: 16px 32px;

            @media screen and (max-width: 1220px) {
              font-size: 18px;
              line-height: 20px;
            }
          }

          &-item {
            position: relative;

            &:last-child {
              &::before {
                display: none;
              }
            }

            &::before {
              width: 2px;
              height: 30px;
              background-color: #3278ba52;
              position: absolute;
              right: -16px;
              top: 50%;
              transform: translateY(-50%);
              display: block;
              content: "";
            }

            &-value {
              font-family: "Roboto Slab", sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 42px;
              text-align: center;
              color: #3278ba;

              @media screen and (max-width: 767px) {
                font-size: 28px;
              }
            }

            &-label {
              font-family: "Roboto", sans-serif;
              font-style: normal;
              font-weight: 400;
              font-size: 20px;
              line-height: 23px;
              text-align: center;
              color: #4c779f;

              @media screen and (max-width: 767px) {
                font-size: 16px;
              }
            }
          }
        }
      }

      &-description {
        margin: 32px 0;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        text-align: center;
        color: #4c779f;

        @media screen and (max-width: 1220px) {
          font-size: 16px;
          line-height: 18px;
        }

        & a {
          text-decoration-line: underline;
        }
      }

      &-button {
        margin: 32px auto 0;
        font-size: 22px;
        padding: 16px 32px;

        @media screen and (max-width: 1220px) {
          font-size: 18px;
          line-height: 20px;
        }
      }
    }
  }

  &__footer {
    padding: 80px 0 0;

    &-glass-block {
      width: 100%;
      border-radius: 20px;
      overflow: hidden;
      padding: 32px 80px;
      background-color: #fff;
      border: 3px solid #095092;

      &-title {
        margin-bottom: 12px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 42px;
        line-height: 55px;
        text-align: center;
        color: #1b5889;

        @media screen and (max-width: 1220px) {
          font-size: 24px;
          line-height: 28px;
        }
      }

      &-description {
        max-width: 60%;
        margin: 0 auto;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        color: #000000;

        @media screen and (max-width: 1220px) {
          font-size: 16px;
          line-height: 24px;
          max-width: none;
        }
      }
    }

    &-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
      margin-top: 40px;

      @media screen and (max-width: 1220px) {
        gap: 20px;
        margin-top: 20px;
      }

      @media screen and (max-width: 767px) {
        grid-template-columns: 1fr;
      }
    }

    &-item {
      border-radius: 20px;
      overflow: hidden;
      padding: 30px 50px;
      background-color: #fff;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 31px;
      color: #000000;
      border: 3px solid #095092;

      @media screen and (max-width: 1220px) {
        padding: 20px 40px;
        font-size: 16px;
        line-height: 24px;
      }
    }

    &-img {
      margin: -36px auto 0;
      max-width: 100%;
    }
  }

  &__sources {
    padding: 32px 0 0;
    background: linear-gradient(180deg, #6996bf 0%, #095092 100%);

    & hr {
      color: #fff;
    }

    &-title {
      margin-top: 16px;
      margin-bottom: 16px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 31px;
      color: #ffffff;

      @media screen and (max-width: 767px) {
        font-size: 18px;
        line-height: 24px;
      }
    }

    &-list {
      list-style-type: decimal;
      margin-left: 1em;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 21px;
      color: #f0f0f0;

      @media screen and (max-width: 767px) {
        font-size: 16px;
        line-height: 21px;
      }

      & li {
        &:not(:last-child) {
          margin-bottom: 8px;

          @media screen and (max-width: 767px) {
            margin-bottom: 4px;
          }
        }
      }
    }
  }

  & .button {
    &_white-blue {
      color: #3278ba;
      background-color: #fff;

      &:hover {
        color: #fff;
        background-color: #1b5889;
      }
    }

    &_blue-white {
      color: #fff;
      background-color: #1b5889;
      border: 1px solid #1b5889;

      &:hover {
        color: #1b5889;
        background-color: #fff;
      }
    }
  }

  & sup {
    vertical-align: super;
    font-family: inherit;
    font-style: normal;
    font-weight: inherit;
    font-size: 65%;
    line-height: 1;
    color: currentColor;
    white-space: nowrap;
  }

  &__casts {
    padding: 120px 0;

    &-title {
      margin-bottom: 40px;
      font-family: 'Roboto Slab', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 55px;
      color: #FFFFFF;
    }

    &-item {
      padding: 20px;
      border: 1px solid #095092;
      border-radius: 15px;
      background-color: #fff;

      @media screen and (max-width: 767px) {
        flex-direction: column;
        gap: 24px;
      }

      &_disabled {
        opacity: .6;
        pointer-events: none;
      }

      &:not(:last-child) {
        margin-bottom: 24px;
      }

      &-head {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      & video {
        margin-top: 24px;
        width: 100%;
        height: auto;
        aspect-ratio: 16/9;
      }

      &-tag {
        margin-right: 40px;
        padding: 12px 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 99px;
        gap: 12px;
        width: fit-content;
        background-color: #1B5889;
        font-family: 'Roboto Slab', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 22px;
        color: #FFFFFF;
        cursor: pointer;

        @media screen and (max-width: 767px) {
          margin-right: 0;
        }
      }

      &-title {
        margin-right: 16px;
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 26px;
        color: #000000;

        @media screen and (max-width: 767px) {
          margin-right: 0;
        }
      }

      &-time {
        margin-left: auto;
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 26px;
        color: #000000;

        @media screen and (max-width: 767px) {
          margin-left: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.bud~.bottom-tip {
  background-color: #095092;
  color: #fff !important;
  margin: 0 !important;
  padding: 32px 0;

  & .content {
    @media screen and (max-width: 1220px) {
      padding: 0 16px;
    }
  }
}
</style>